module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Amy Lane’s Greatest Hits: Amy’s Alternative Universe includes:")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-Center"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "",
      "src": "image0.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("When Teyth was but a child, a cruel prince took over his village, building a great granite tower to rule over the folk. Greedy and capricious, the man will be the bane of Teyth’s existence as an adult, but as a boy, Teyth is too busy escaping his stepfather to worry about his ruler.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sold into apprenticeship to the local blacksmith, Teyth finds that what was meant as a punishment is actually his salvation. Cairsten, the smith, and Diarmuid, his adopted son, are kind, and the smithy is the prosperous heart of a thriving village. As Teyth grows in the craft of metalwork, he also grows in love for Diarmuid, the gentle, clever young man who introduces him to smithing.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Their prince wants Diarmuid too. As the tyrant inflicts loss upon loss on Teyth and Diarmuid, Teyth’s passion for his craft twists into obsession. By the time Teyth resurfaces from his quest to create immortality, he’s nearly lost the love that makes being human worth the pain. Teyth was born to sculpt his emotion into metal, and Diarmuid was born to lead. Together, can they keep their village safe and sustain the love that will make them immortal?")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Page_Break"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-Center"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "",
      "src": "image1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ten years after Dorjan trusted a boy’s word over his superior officer’s, he and his best friend, Areau, are still living the aftermath—and trying to stop the man responsible. Locked in a careful dance to bring down a corrupt government, Dorjan struggles to balance his grief with Areau’s anger. Just when Dorjan reaches the end of his rope, he sees a familiar face in the shadows, and the boy he trusted a decade before offers him unexpected kindness.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Taern remembers the soldier who found him under the rushes and listened to his pleas to save his family. When Dorjan reappears in his life, Taern is both captured by his commitment to justice and terrified by the risks he takes. All Taern wants to do is fix him, but the oncoming destruction has been ten years in the making, and Dorjan doesn’t want his help. Not if it puts Taern at risk.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Powers clash and a world’s fate dangles between Areau’s madness and Dorjan’s nobility. While Dorjan fights to save the world, Taern joins the battle simply to save Dorjan, knowing everything hinges on the heart of a man in armor and the strength of the man who loves him.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Page_Break"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-Center"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "",
      "src": "image2.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("“I am not beautiful...”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Knife’s entire existence has been as twisted as his flesh and his face. The only thing beautiful in his life is his sister. When Gwennie is obliged to turn a suitor down because she fears to leave her brother to the brutality of their village, Knife is desperate for anything to ensure her happiness.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Her suitor’s cousin offers him a way out, but it won’t be easy. Aerie-Smith has been cursed to walk upright in the form of a beast, and his beloved village suffers from the same spell. Aerie-Smith offers Gwen a trousseau and some hope, if only Knife will keep him company on his island for the span of a year and perform one “regrettable task” at year’s end.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Knife is unprepared for the form the island’s curse takes on his own misshapen body. In one moment of magic, he is given the body of his dreams—and he discovers that where flesh meets spirit and appearance meet reality, sometimes the only place to find truth is in the darkness of a lover’s arms.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Page_Break"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-Center"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "",
      "src": "image3.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("There will always be a Hammer and an Air....")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Graeme and Eirn have no words for what they are to each other. Children, clinging together in a crowded orphanage; friends, battling back to back in a school yard; and bedmates, finally bridging the gap between sleeping next to a body and allowing it to touch you in the night—all of these roles are summed up by just their names: Hammer and Air.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The innocent exploration of their newest roles is brutally marred when a violent, ill-tempered master threatens Eirn, and Eirn’s “Hammer” kills the man in a fair fight. The two run off into the wide world with only each other for safety. It’s difficult to forge a good life with only a blacksmith’s hammer and a printer’s cleverness, but together, Hammer and Eirn will learn to negotiate the dangers of magic and motion, of sex, obsession, and tenderness, and of the word that can make sense of it all—one word they must earn for themselves.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 60
// module chunks = 0